<template>
  <div
    class="dropzone"
    v-on:click="openFileSelection"
    v-on:dragover="onDragOver"
    v-on:dragleave="onDragLeave"
    v-on:drop="onDrop"
    v-bind:class="{ hightlight: hightlight, disabled: !enabled }"
  >
    <span>
      <slot>Add files</slot>
    </span>
    <input
      ref="fileInput"
      class="file-input"
      type="file"
      :multiple="multiple"
      v-on:change="onFileChanged"
      :accept="accept"
    />
  </div>
</template>

<script>
export default {
  props: {
    enabled: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      hightlight: false
    };
  },
  methods: {
    openFileSelection() {
      if (!this.enabled) return;
      this.$refs.fileInput.click();
    },
    onDragOver(event) {
      if (!this.enabled) return;
      event.preventDefault();
      this.hightlight = true;
    },
    /* eslint-disable-next-line no-unused-vars */
    onDragLeave(event) {
      this.hightlight = false;
    },
    onDrop(event) {
      if (!this.enabled) return;
      event.preventDefault();
      const files = event.dataTransfer.files;
      let result = [];
      const types = this.accept.split(",");
      for (var i = 0; i < files.length; i++) {
        const file = files.item(i);
        const fileType = file.name.substring(file.name.lastIndexOf("."));
        if (types.includes(fileType)) result.push(file);
      }
      this.$emit("filesAdded", this.multiple ? result : result[0]);
      this.hightlight = false;
    },
    onFileChanged(event) {
      let files = event.target.files;
      let result = [];
      for (var i = 0; i < files.length; i++) {
        result.push(files.item(i));
      }
      this.$emit("filesAdded", this.multiple ? result : result[0]);
    }
  }
};
</script>

<style lang="scss" scoped>
.dropzone {
  position: relative;
  border: 3px dashed theme("colors.darkendtextcolor");
  color: theme("colors.darkendtextcolor");
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  border-radius: 0.5rem;

  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.hightlight {
  background-color: theme("colors.highlight");
}

.disabled {
  // border: 3px dashed darken($darkendtextcolor, 20%);
  // color: darken($darkendtextcolor, 20%);
  cursor: default;
}

.file-input {
  display: none;
}
</style>
